import React from 'react'
import { Helmet } from 'react-helmet'
import LiveTemplateDefault from 'src/components/template/live'
import { sportIds, leagueIds } from 'src/constants/personalizationIds'
import { networkLogos } from 'src/constants'
import { createVideoStructuredData } from 'src/modules/utils/videoStructuredData'

export default (props) => {
  const videoStructuredData = createVideoStructuredData({
    networkName: 'NFL Network',
    callsign: 'NFLHD',
    logoUrl: networkLogos.nflnetwork.logoUrl,
    slug: 'nfl-network',
  })

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(videoStructuredData)}</script>
      </Helmet>
      <LiveTemplateDefault
        location={props.location}
        lang="en"
        market="us"
        callsign="NFLHD"
        title="Watch NFL Network live with Fubo"
        networkSet="nfl"
        // Remove cable references
        removeCable={true}
        networkName="NFL Network"
        matchtickerSportId="111"
        matchtickerLeagueName="NFL"
        matchtickerLeagueId="191277"
        showRedzone={false}
        sportId={sportIds.Football}
        leagueId={leagueIds.NFL}
      />
    </>
  )
}
